import { countries, getEmojiFlag, type TCountryCode } from 'countries-list';
import type { JSONSchema7Definition } from 'json-schema';

export const COUNTRY_OPTIONS: JSONSchema7Definition[] = Object.keys(countries)
  .map((countryCode) => ({
    title: countries[countryCode as TCountryCode].name,
    const: countryCode,
  }))
  .sort((a, b) => a.title.localeCompare(b.title));

export const COUNTRY_ICONS = Object.keys(countries).map((countryCode) => ({
  const: countryCode,
  icon: getEmojiFlag(countryCode as TCountryCode),
}));
